import { useState, useMemo, useRef } from "react";
import { MdClose, MdDelete, MdSearch, MdVisibility } from "react-icons/md";
import dayjs from "dayjs";
import {
  Tabs,
  Tab,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  InputAdornment,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
} from "@mui/material";



const tabsData = [
  "OFAC",
  "PEP",
  "UK sanctions",
  "NON SDN",
  "Grey List",
  "White List",
];

const scenarioOptions = ["phonetic Substitution", "Abbreviation", "Bad Data"];

const DataProcessingNew4 = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [rowsByTab, setRowsByTab] = useState(() => {
    const obj = {};
    tabsData.forEach((tab) => {
      const date0 = dayjs();
      const date1 = dayjs().subtract(1, "day");
      const date2 = dayjs().subtract(2, "day");
      const file0 = `${tab.toLowerCase().replace(/\s+/g, "-")}-${date0.format(
        "DD-MM-YYYY"
      )}-${date0.format("HHmmss")}.pdf`;
      const file1 = `${tab.toLowerCase().replace(/\s+/g, "-")}-${date1.format(
        "DD-MM-YYYY"
      )}-${date1.format("HHmmss")}.pdf`;
      const file2 = `${tab.toLowerCase().replace(/\s+/g, "-")}-${date2.format(
        "DD-MM-YYYY"
      )}-${date2.format("HHmmss")}.pdf`;
      obj[tab] = [
        {
          id: 1,
          type: "Current",
          fileName: [file0],
          scenario: ["phonetic Substitution"],
        },
        {
          id: 2,
          type: "History",
          fileName: [file1],
          scenario: ["Abbreviation"],
        },
        { id: 3, type: "History", fileName: [file2], scenario: ["Bad Data"] },
      ];
    });
    return obj;
  });
  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState("Current");
  const [modalFile, setModalFile] = useState([]);
  const [modalScenario, setModalScenario] = useState([]);
  const [showPreviewTable, setShowPreviewTable] = useState(false);
  const [previewFileName, setPreviewFileName] = useState("");
  
  const [scenarioSearch, setScenarioSearch] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const handleTabChange = (idx) => setSelectedTab(idx);
  const currentTab = tabsData[selectedTab];
  const rows = rowsByTab[currentTab];

  const fileOptions = useMemo(() => {
    const tab = tabsData[selectedTab];
    return Array.from({ length: 10 }, (_, index) => {
      const date = dayjs().subtract(index, "days");
      const dateStr = date.format("DD-MM-YYYY");
      const timestampStr = date.format("HHmmss");
      return `${tab
        .toLowerCase()
        .replace(/\s+/g, "-")}-${dateStr}-${timestampStr}.pdf`;
    });
  }, [selectedTab]);

  const previewTableData = [
  {
    id: 1,
    col1: "'ABBAS, Yasir",
    col2: "'ABBAS, Iasir",
    col3: "phonetic Substitution",
  },
  {
    id: 2,
    col1: "'ABBAS, Rim",
    col2: "'ABBAS, Rym",
    col3: "phonetic Substitution",
  },
  {
    id: 3,
    col1: "'ABBAS, Yasir",
    col2: "'ABBAS, Yasyr",
    col3: "phonetic Substitution",
  },
  {
    id: 4,
    col1: "ANGLO-CARIBBEAN CO., LTD.",
    col2: "ANGLO-CARIBBEAN COMPANY LTD.",
    col3: "Abbreviation",
  },
  {
    id: 5,
    col1: "CECOEX, S.A.",
    col2: "CECOEX, Sociedad Anónima",
    col3: "Abbreviation",
  },
  {
    id: 6,
    col1: "CIMEX, S.A.",
    col2: "CIMEX, Sociedad Anónima",
    col3: "Abbreviation",
  },
  {
    id: 7,
    col1: "AEROCARIBBEAN AIRLINES",
    col2: "AEROCkbARIBBEAN AIRLINES",
    col3: "Bad Data",
  },
  {
    id: 8,
    col1: "ANGLO-CARIBBEAN CO., LTD.",
    col2: "ANGLO-CARIBppBEAN CO., LTD.",
    col3: "Bad Data",
  },
  {
    id: 9,
    col1: "BANCO NACIONAL DE CUBA",
    col2: "BANCO NACIOsbNAL DE CUBA",
    col3: "Bad Data",
  },
  {
    id: 10,
    col1: "BOUTIQUE LA MAISON",
    col2: "BOUTIQUE kiLA MAISON",
    col3: "Bad Data",
  },
];

  const filteredPreviewTableData = previewTableData.filter((row) => {
    const searchLower = searchTerm.toLowerCase();
    return (
      row.col1?.toLowerCase().includes(searchLower) ||
      row.col2?.toLowerCase().includes(searchLower) ||
      row.col3?.toLowerCase().includes(searchLower)
    );
  });

  const handleDeleteRow = (id) => {
    setRowsByTab((prev) => ({
      ...prev,
      [currentTab]: prev[currentTab].filter((row) => row.id !== id),
    }));
  };

  const handleOpenModal = () => {
    setModalType("Current");
    setModalFile([]);
    setModalScenario([]);
    setModalOpen(true);
  };

  const handleCloseModal = () => setModalOpen(false);

  const handleSaveCombination = () => {
    if (modalFile.length > 0 && modalScenario.length > 0) {
      setRowsByTab((prev) => ({
        ...prev,
        [currentTab]: [
          ...prev[currentTab],
          {
            id: Date.now(),
            type: modalType,
            fileName: modalFile,
            scenario: modalScenario,
          },
        ],
      }));
      setModalOpen(false);
    }
  };

  // For Add New Scenario Modal
  const handleModalTypeChange = (e) => {
    const value = e.target.value;
    setModalType(value);
    const tab = tabsData[selectedTab];
    if (value === "Current") {
      const date = dayjs();
      const file = `${tab.toLowerCase().replace(/\s+/g, "-")}-${date.format(
        "DD-MM-YYYY"
      )}-${date.format("HHmmss")}.pdf`;
      setModalFile([file]);
    } else if (value === "History") {
      setModalFile([]); // Let user select from dropdown
    }
  };
  // For View Files Modal
  const [viewFilesModal, setViewFilesModal] = useState(false);
  // Add separate states for modal view
  const [modalSelectedFile, setModalSelectedFile] = useState(null);
  const [modalSearchTerm, setModalSearchTerm] = useState("");
  const [modalCurrentPage, setModalCurrentPage] = useState(1);
  const modalItemsPerPage = 5;

  // Add this after the existing state declarations
  const [modalPreviewCurrentPage, setModalPreviewCurrentPage] = useState(1);
  const itemsPerPage = 5;
  // Add this function to filter table data
  const getFilteredTableData = () => {
    const allData = previewTableData;
    if (!searchTerm) return allData;

    return allData.filter((row) =>
      Object.values(row).some(
        (value) => value && value.toString().toLowerCase().includes(searchTerm)
      )
    );
  };

  const getFilteredModalPreviewData = () => {
    const allData = modalPreviewTableData;
    const searchTerm = modalSearchTerm?.toLowerCase().trim();

    if (!searchTerm) return allData;

    return allData.filter((row) =>
      Object.values(row).some((value) =>
        value?.toString().toLowerCase().includes(searchTerm)
      )
    );
  };
  // Add pagination functions for modal table
  const handleModalFirstPage = () => {
    setModalCurrentPage(1);
  };

  const handleModalLastPage = () => {
    setModalCurrentPage(
      Math.ceil(tableData[tabsData[selectedTab]].length / modalItemsPerPage)
    );
  };

  const handleModalPrevPage = () => {
    setModalCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleModalNextPage = () => {
    setModalCurrentPage((prev) =>
      Math.min(
        prev + 1,
        Math.ceil(tableData[tabsData[selectedTab]].length / modalItemsPerPage)
      )
    );
  };

  // Add pagination functions for modal preview table
  const handleModalPreviewFirstPage = () => {
    setModalPreviewCurrentPage(1);
  };

  const handleModalPreviewLastPage = () => {
    setModalPreviewCurrentPage(
      Math.ceil(getFilteredTableData().length / itemsPerPage)
    );
  };

  const handleModalPreviewPrevPage = () => {
    setModalPreviewCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleModalPreviewNextPage = () => {
    setModalPreviewCurrentPage((prev) =>
      Math.min(
        prev + 1,
        Math.ceil(getFilteredTableData().length / itemsPerPage)
      )
    );
  };

  // Add modal search handler
  const handleModalSearch = (event) => {
    setModalSearchTerm(event.target.value.toLowerCase());
  };

  // Add modal view file handler
  const handleModalViewFile = (file) => {
    setModalSelectedFile(file);
    // Delay to ensure preview content renders first
  };

  const modalPreviewTableData = [
    {
      id: 0,
      col1: "BANKSESSXXXX",
      col2: "I103BANKNO2XXXXN",
      col3: "SEPA, MNO987123654",
      col4: "",
      col20: "REF987123654",
      col23B: "CRED",
      col32A: "240303SEK3000",
      col50A: "/9871236540 OLIVER ERICSON",
      col57A: "BANKNO2X",
      col59: "/5566778899 HENRY JOHNSTON",
      col70: "HOUSE RENT",
      col71A: "SHA",
      col72: "/INS/SAME DAY PROCESSING",
    },
    {
      id: 1,
      col1: "BANKFIHHXXXX",
      col2: "I103BANKDKKKXXXXN",
      col3: "SEPA, PQR456789123",
      col4: "",
      col20: "REF456789123",
      col23B: "CRED",
      col32A: "240303SEK5000",
      col50A: "/4567891230 EMMA WILSON",
      col57A: "BANKDKKKX",
      col59: "/1122334455 JAMES BROWN",
      col70: "CAR LOAN",
      col71A: "SHA",
      col72: "/INS/SAME DAY PROCESSING",
    },
    {
      id: 2,
      col1: "BANKPTPLXXXX",
      col2: "I103BANKGRXXXXXXN",
      col3: "SEPA, STU654321987",
      col4: "",
      col20: "REF654321987",
      col23B: "CRED",
      col32A: "240303SEK7000",
      col50A: "/6543219870 LUCAS MARTIN",
      col57A: "BANKGRXXX",
      col59: "/9988776655 SARAH DAVIS",
      col70: "HOME RENOVATION",
      col71A: "SHA",
      col72: "/INS/SAME DAY PROCESSING",
    },
    {
      id: 3,
      col1: "BANKESPBXXXX",
      col2: "I103BANKITRRXXXXN",
      col3: "SEPA, VWX321654987",
      col4: "",
      col20: "REF321654987",
      col23B: "CRED",
      col32A: "240303SEK4000",
      col50A: "/3216549870 SOPHIA LEE",
      col57A: "BANKITRRX",
      col59: "/4455667788 MICHAEL WHITE",
      col70: "EDUCATION",
      col71A: "SHA",
      col72: "/INS/SAME DAY PROCESSING",
    },
    {
      id: 4,
      col1: "BANKDEFFXXXX",
      col2: "I103BANKFRXXXXXXN",
      col3: "SEPA, YZA987654321",
      col4: "",
      col20: "REF987654321",
      col23B: "CRED",
      col32A: "240303SEK6000",
      col50A: "/9876543210 THOMAS CLARK",
      col57A: "BANKFRXXX",
      col59: "/6677889900 LUCY ADAMS",
      col70: "BUSINESS EXPENSE",
      col71A: "SHA",
      col72: "/INS/SAME DAY PROCESSING",
    },
  ];

  // Add this table data
  const tableData = {
    OFAC: [
      {
        id: 1,
        fileName: "ofac-2024-03-15-120000",
        loadDate: "15-03-2024",
        loadTime: "12:00:00",
      },
      {
        id: 2,
        fileName: "ofac-2024-03-14-150000",
        loadDate: "14-03-2024",
        loadTime: "15:00:00",
      },
      {
        id: 3,
        fileName: "ofac-2024-03-13-180000",
        loadDate: "13-03-2024",
        loadTime: "18:00:00",
      },
    ],
    PEP: [
      {
        id: 1,
        fileName: "pep-2024-03-15-130000",
        loadDate: "15-03-2024",
        loadTime: "13:00:00",
      },
      {
        id: 2,
        fileName: "pep-2024-03-14-160000",
        loadDate: "14-03-2024",
        loadTime: "16:00:00",
      },
      {
        id: 3,
        fileName: "pep-2024-03-13-190000",
        loadDate: "13-03-2024",
        loadTime: "19:00:00",
      },
    ],
    "UK sanctions": [
      {
        id: 1,
        fileName: "uk-sanctions-2024-03-15-140000",
        loadDate: "15-03-2024",
        loadTime: "14:00:00",
      },
      {
        id: 2,
        fileName: "uk-sanctions-2024-03-14-170000",
        loadDate: "14-03-2024",
        loadTime: "17:00:00",
      },
      {
        id: 3,
        fileName: "uk-sanctions-2024-03-13-200000",
        loadDate: "13-03-2024",
        loadTime: "20:00:00",
      },
    ],
    "NON SDN": [
      {
        id: 1,
        fileName: "non-sdn-2024-03-15-150000",
        loadDate: "15-03-2024",
        loadTime: "15:00:00",
      },
      {
        id: 2,
        fileName: "non-sdn-2024-03-14-180000",
        loadDate: "14-03-2024",
        loadTime: "18:00:00",
      },
      {
        id: 3,
        fileName: "non-sdn-2024-03-13-210000",
        loadDate: "13-03-2024",
        loadTime: "21:00:00",
      },
    ],
    "Grey List": [
      {
        id: 1,
        fileName: "grey-list-2024-03-15-160000",
        loadDate: "15-03-2024",
        loadTime: "16:00:00",
      },
      {
        id: 2,
        fileName: "grey-list-2024-03-14-190000",
        loadDate: "14-03-2024",
        loadTime: "19:00:00",
      },
      {
        id: 3,
        fileName: "grey-list-2024-03-13-220000",
        loadDate: "13-03-2024",
        loadTime: "22:00:00",
      },
    ],
    "White List": [
      {
        id: 1,
        fileName: "white-list-2024-03-15-170000",
        loadDate: "15-03-2024",
        loadTime: "17:00:00",
      },
      {
        id: 2,
        fileName: "white-list-2024-03-14-200000",
        loadDate: "14-03-2024",
        loadTime: "20:00:00",
      },
      {
        id: 3,
        fileName: "white-list-2024-03-13-230000",
        loadDate: "13-03-2024",
        loadTime: "23:00:00",
      },
    ],
    Others: [
      {
        id: 1,
        fileName: "others-2024-03-15-180000",
        loadDate: "15-03-2024",
        loadTime: "18:00:00",
      },
      {
        id: 2,
        fileName: "others-2024-03-14-210000",
        loadDate: "14-03-2024",
        loadTime: "21:00:00",
      },
      {
        id: 3,
        fileName: "others-2024-03-13-240000",
        loadDate: "13-03-2024",
        loadTime: "24:00:00",
      },
    ],
  };

    const [scenarioType, setScenarioType] = useState("Positive");
    const [dynamicScenarioOptions, setDynamicScenarioOptions] = useState(scenarioOptions);

    const handleScenarioTypeChange = (e) => {
    const value = e.target.value;
    setScenarioType(value);
    if (value === "Positive") {
        setDynamicScenarioOptions([]);
    } else if (value === "Negative") {
        setDynamicScenarioOptions(["phonetic Substitution", "Abbreviation", "Bad Data"]);
    } else if (value === "Variations") {
        setDynamicScenarioOptions(["Anglized Words", "Bad Data", "Double Letters", "Initails", "Intervening Words", "Missing Words", "Nicknames", "Run Together", "Symbolic Replacement", "First_Last_Name_Swap", "Phonetic Substition", "Name Aliases"]);
    }
    setModalScenario([]); 
    };

  return (
    <div className="efficiency-page">
      <div className="page-container">
        {/* MUI Tabs */}
        <div className="border-bottom" style={{ borderColor: "divider" }}>
          <Tabs
            value={selectedTab}
            onChange={(e, idx) => handleTabChange(idx)}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="data processing tabs"
            sx={{
              "& .MuiTabs-indicator": { display: "none" },
              "& .MuiTab-root": {
                color: "rgba(0, 0, 0, 0.6)",
                backgroundColor: "#ccc",
                padding: "15px",
                borderRadius: "4px 4px 0 0",
                marginRight: "5px",
                "&.Mui-selected": {
                  backgroundColor: "var(--theme-color)",
                  color: "white",
                  borderRadius: "4px 4px 0 0",
                },
              },
            }}
          >
            {tabsData.map((tab, idx) => (
              <Tab key={tab} label={tab} />
            ))}
          </Tabs>
        </div>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="justify-content-start">
            <button
              className="anchor-button"
              onClick={() => setViewFilesModal(true)}
            >
              View Files
            </button>
          </div>
          <div className="justify-content-end">
            <Button
              variant="contained"
              color="primary"
              style={{ backgroundColor: "var(--theme-color)", color: "#fff" }}
              onClick={handleOpenModal}
            >
              + Add New Scenario
            </Button>
          </div>
        </div>
        {/* Table Section - use Bootstrap table */}
        <div className="table-responsive mb-3">
          <table className="table table-bordered table-striped">
            <thead className="table-dark">
              <tr>
                <th>Current/History</th>
                <th>File Name</th>
                <th>Scenario</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.id}>
                  <td>{row.type}</td>
                  <td>
                    {Array.isArray(row.fileName)
                      ? row.fileName.join(", ")
                      : row.fileName}
                  </td>
                  <td>
                    {Array.isArray(row.scenario)
                      ? row.scenario.join(", ")
                      : row.scenario}
                  </td>
                  <td>
                    <IconButton
                      color="error"
                      size="small"
                      onClick={() => handleDeleteRow(row.id)}
                    >
                      <MdDelete />
                    </IconButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="row justify-content-center mt-3">
          <div className="col-auto">
            <Button
              variant="contained"
              style={{ backgroundColor: "var(--theme-color)", color: "#fff" }}
              onClick={() => setShowPreviewTable(true)}
            >
              Submit
            </Button>
          </div>
        </div>
        {/* Preview Table Section - use Bootstrap table */}
        {showPreviewTable && (
          <div className="card mt-3">
            <div className="card-body p-3">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h5 className="mb-0">Preview Data</h5>
                <FormControl size="small" sx={{ minWidth: 200 }}>
                  <InputLabel>File Name</InputLabel>
                  <Select
                    value={previewFileName}
                    label="File Name"
                    onChange={(e) => setPreviewFileName(e.target.value)}
                  >
                    <MenuItem value="">File Name</MenuItem>
                    {fileOptions.map((file) => (
                      <MenuItem key={file} value={file}>
                        {file}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <div style={{ maxWidth: 350, marginBottom: 24 }}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <MdSearch />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead className="table-dark">
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Processed Name</th>
                      <th>Scenario</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredPreviewTableData.map((row, idx) => (
                      <tr key={row.id}>
                        <td>{idx + 1}</td>
                        <td>{row.col1}</td>
                        <td>{row.col2}</td>
                        <td>{row.col3}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
        {/* Modal for Add New Scenario - use MUI Dialog */}
        <Dialog
          open={modalOpen}
          onClose={handleCloseModal}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle sx={{ fontWeight: 600 }}>Add New Scenario</DialogTitle>
          <DialogContent>
            <div style={{ marginBottom: 16 }}>
              <div style={{ fontWeight: 500, marginBottom: 4 }}>
                Current/History
              </div>
              <FormControl fullWidth size="small">
                <Select value={modalType} onChange={handleModalTypeChange}>
                  <MenuItem value="Current">Current</MenuItem>
                  <MenuItem value="History">History</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div style={{ marginBottom: 16 }}>
              <div style={{ fontWeight: 500, marginBottom: 4 }}>File Name</div>
              {modalType === "Current" ? (
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  value={modalFile[0] || ""}
                  InputProps={{ readOnly: true }}
                />
              ) : (
                <FormControl fullWidth size="small">
                  <Select
                    value={modalFile[0] || ""}
                    onChange={(e) => setModalFile([e.target.value])}
                    renderValue={(selected) => selected}
                  >
                    {fileOptions.slice(0, 3).map((file) => (
                      <MenuItem key={file} value={file}>
                        {file}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            </div>
            {/* Here */}
            <div style={{ marginBottom: 16 }}>
                <div style={{ fontWeight: 500, marginBottom: 4 }}>Scenario Type</div>
              <FormControl fullWidth size="small">
                <Select
                    value={scenarioType}
                    onChange={handleScenarioTypeChange}
                    >
                    <MenuItem value="Positive">Positive</MenuItem>
                    <MenuItem value="Negative">Negative</MenuItem>
                    <MenuItem value="Variations">Variations</MenuItem>
                    </Select>
              </FormControl>
            </div>
            {scenarioType !== "Positive" && (
            <div className="mb-2">
              <div style={{ fontWeight: 500, marginBottom: 4 }}>Scenario</div>

              <FormControl fullWidth size="small">
                <Select
      multiple
      value={modalScenario}
      onChange={(e) => setModalScenario(e.target.value)}
      renderValue={(selected) => selected.join(", ")}
    >
      <MenuItem
        value="__all__"
        onClick={() => {
          if (modalScenario.length === dynamicScenarioOptions.length) {
            setModalScenario([]);
          } else {
            setModalScenario(dynamicScenarioOptions);
          }
        }}
      >
        <Checkbox
          checked={modalScenario.length === dynamicScenarioOptions.length}
          indeterminate={
            modalScenario.length > 0 &&
            modalScenario.length < dynamicScenarioOptions.length
          }
        />
        <ListItemText primary="Select All" />
      </MenuItem>
      {dynamicScenarioOptions
        .filter((s) =>
          s.toLowerCase().includes(scenarioSearch.toLowerCase())
        )
        .map((s) => (
          <MenuItem key={s} value={s}>
            <Checkbox checked={modalScenario.indexOf(s) > -1} />
            <ListItemText primary={s} />
          </MenuItem>
        ))}
    </Select>
              </FormControl>
            </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseModal} variant="outlined">
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              disabled={modalFile.length === 0 || modalScenario.length === 0}
              onClick={handleSaveCombination}
            >
              Save Scenario
            </Button>
          </DialogActions>
        </Dialog>

       {viewFilesModal && (
  <div className="modal-overlay">
    <div
      className="modal-container bg-white"
      style={{
        maxWidth: "90%",
        width: "90%",
        maxHeight: "90vh", // Set maximum height to 90% of viewport height
        height: "auto",
        overflowY: "auto", // Enable vertical scrolling for the entire modal
        display: "flex",
        flexDirection: "column"
      }}
    >
      {/* Header Section */}
      <div className="row justify-content-center align-items-center bg-white z-index-1">
        <div className="col-12 d-flex justify-content-between align-items-center py-3 border-bottom">
          <h5 className="m-0 px-2">View Files</h5>
          <button
            className="border-0 bg-transparent"
            onClick={() => {
              setViewFilesModal(false);
              setModalSelectedFile(null);
              setModalSearchTerm("");
              setModalCurrentPage(1);
            }}
          >
            <MdClose color="black" fontSize={20} />
          </button>
        </div>
      </div>

      {/* Main Content with Single Scroll */}
      <div className="modal-body p-3">
        {/* Table Section (File List) - Always visible */}
        <div className="mb-4">
          <h6 className="mb-3">File List</h6>
          <div className="table-responsive border rounded bg-white shadow-sm">
            <table className="table table-bordered table-striped mb-0">
              <thead className="table-dark">
                <tr>
                  <th>#</th>
                  <th>File Name</th>
                  <th>Load Date</th>
                  <th>Load Time</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {tableData[tabsData[selectedTab]]
                  .slice(
                    (modalCurrentPage - 1) * modalItemsPerPage,
                    modalCurrentPage * modalItemsPerPage
                  )
                  .map((row, index) => (
                    <tr key={row.id}>
                      <td>
                        {(modalCurrentPage - 1) * modalItemsPerPage +
                          index +
                          1}
                      </td>
                      <td>{row.fileName}</td>
                      <td>{row.loadDate}</td>
                      <td>{row.loadTime}</td>
                      <td className="text-center">
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          startIcon={<MdVisibility />}
                          onClick={() => handleModalViewFile(row)}
                        >
                          View
                        </Button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>

          {/* Pagination Controls for File Table */}
          <div className="d-flex justify-content-end mt-3">
            <div className="pagination">
              <Button
                variant="outlined"
                size="small"
                onClick={handleModalFirstPage}
                disabled={modalCurrentPage === 1}
                className="me-2"
              >
                First
              </Button>
              <Button
                variant="outlined"
                size="small"
                onClick={handleModalPrevPage}
                disabled={modalCurrentPage === 1}
                className="me-2"
              >
                Prev
              </Button>
              <span className="mx-2 align-self-center">
                Page {modalCurrentPage} of{" "}
                {Math.ceil(
                  tableData[tabsData[selectedTab]].length /
                    modalItemsPerPage
                )}
              </span>
              <Button
                variant="outlined"
                size="small"
                onClick={handleModalNextPage}
                disabled={
                  modalCurrentPage ===
                  Math.ceil(
                    tableData[tabsData[selectedTab]].length /
                      modalItemsPerPage
                  )
                }
                className="me-2"
              >
                Next
              </Button>
              <Button
                variant="outlined"
                size="small"
                onClick={handleModalLastPage}
                disabled={
                  modalCurrentPage ===
                  Math.ceil(
                    tableData[tabsData[selectedTab]].length /
                      modalItemsPerPage
                  )
                }
              >
                Last
              </Button>
            </div>
          </div>
        </div>

        {/* Preview Section - Appears when a file is selected, but doesn't collapse the first table */}
        {modalSelectedFile && (
          <div className="mt-4 pt-2 border-top">
            <h6 className="mb-3">File Preview: {modalSelectedFile.fileName}</h6>
            <div className="row mb-3 justify-content-between">
              <div className="col-md-4">
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  placeholder="Search"
                  value={modalSearchTerm}
                  onChange={handleModalSearch}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <MdSearch />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </div>
            <div className="table-responsive border rounded">
              <table
                className="table table-bordered table-striped mb-0"
                id="filePreviewTable"
              >
                <thead className="table-dark">
                  <tr>
                    <th>#</th>
                    <th>ENT_NUM</th>
                    <th>SDN_NAME</th>
                    <th>SDN_TYPE</th>
                    <th>Program</th>
                    <th>Title</th>
                    <th>Call_Sign</th>
                    <th>Vessel_Type</th>
                    <th>Tonnage</th>
                    <th>GRT</th>
                    <th>Vessel_Flag</th>
                    <th>Vessel_Owner</th>
                    <th>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  {getFilteredModalPreviewData().map((row, index) => (
                    <tr key={row.ENT_NUM || index}>
                      <td>{index + 1}</td>
                      <td>{row.ENT_NUM}</td>
                      <td>{row.SDN_NAME}</td>
                      <td>{row.SDN_TYPE}</td>
                      <td>{row.Program}</td>
                      <td>{row.Title}</td>
                      <td>{row.Call_Sign}</td>
                      <td>{row.Vessel_Type}</td>
                      <td>{row.Tonnage}</td>
                      <td>{row.GRT}</td>
                      <td>{row.Vessel_Flag}</td>
                      <td>{row.Vessel_Owner}</td>
                      <td>{row.Remarks}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {/* Pagination Controls for Preview Table */}
            <div className="d-flex justify-content-end mt-3">
              <div className="pagination">
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleModalPreviewFirstPage}
                  disabled={modalPreviewCurrentPage === 1}
                  className="me-2"
                >
                  First
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleModalPreviewPrevPage}
                  disabled={modalPreviewCurrentPage === 1}
                  className="me-2"
                >
                  Prev
                </Button>
                <span className="mx-2 align-self-center">
                  Page {modalPreviewCurrentPage} of{" "}
                  {Math.ceil(
                    getFilteredModalPreviewData().length / itemsPerPage
                  )}
                </span>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleModalPreviewNextPage}
                  disabled={
                    modalPreviewCurrentPage ===
                    Math.ceil(
                      getFilteredModalPreviewData().length / itemsPerPage
                    )
                  }
                  className="me-2"
                >
                  Next
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleModalPreviewLastPage}
                  disabled={
                    modalPreviewCurrentPage ===
                    Math.ceil(
                      getFilteredModalPreviewData().length / itemsPerPage
                    )
                  }
                >
                  Last
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  </div>
)}
      </div>
    </div>
  );
};

export default DataProcessingNew4;
